/**
 * @generated SignedSource<<634cb7ee094bcf9933bfc8e0466b8be4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RestaurantsPageQuery$variables = {};
export type RestaurantsPageQuery$data = {
  readonly adminRestaurants: ReadonlyArray<{
    readonly id: string;
    readonly isApproved: boolean;
    readonly isPublic: boolean;
    readonly lastVisibilityChange: {
      readonly adminName: string;
      readonly createdAt: any;
      readonly isPublic: boolean;
      readonly reason: string | null;
    } | null;
    readonly name: string;
    readonly ownerEmail: string | null;
    readonly slug: string;
  }>;
};
export type RestaurantsPageQuery = {
  response: RestaurantsPageQuery$data;
  variables: RestaurantsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPublic",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminRestaurant",
    "kind": "LinkedField",
    "name": "adminRestaurants",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isApproved",
        "storageKey": null
      },
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminVisibilityChange",
        "kind": "LinkedField",
        "name": "lastVisibilityChange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminName",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RestaurantsPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RestaurantsPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "943c643aea8292dbf9458b714b0be93b",
    "id": null,
    "metadata": {},
    "name": "RestaurantsPageQuery",
    "operationKind": "query",
    "text": "query RestaurantsPageQuery {\n  adminRestaurants {\n    id\n    name\n    slug\n    ownerEmail\n    isApproved\n    isPublic\n    lastVisibilityChange {\n      adminName\n      isPublic\n      reason\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7f08186ce7b4ed718d943e6e4b49e2a";

export default node;
